"use strict";

exports.__esModule = true;
var _DataItemChartV2Element = require("./DataItemChartV2Element");
Object.keys(_DataItemChartV2Element).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemChartV2Element[key]) return;
  exports[key] = _DataItemChartV2Element[key];
});
var _DataItemChartV2Fields = require("./DataItemChartV2Fields");
Object.keys(_DataItemChartV2Fields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemChartV2Fields[key]) return;
  exports[key] = _DataItemChartV2Fields[key];
});
var _DataItemChartV2Thumbnail = require("./DataItemChartV2Thumbnail");
Object.keys(_DataItemChartV2Thumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DataItemChartV2Thumbnail[key]) return;
  exports[key] = _DataItemChartV2Thumbnail[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});